module.exports = __webpack_public_path__ + "static/media/tuto.996a4342.mp4";